import React, { ReactElement, useEffect } from 'react';

import Carousel from 'atomic/carousel/carousel';
import { useCompany } from 'hooks/use-selector';
import CompanyViewBestOffersItem from 'components/company-view/best-offers/item/company-view-best-offers-item';
import CompanyViewBestOffersNav from 'components/company-view/best-offers/nav/company-view-best-offers-nav';

import './company-view-best-offers.desktop.scss';

const CompanyViewBestOffersDesktop: React.FC = (): ReactElement | null => {
    const company = useCompany();

    if (!company.offers.length) {
        return null;
    }

    useEffect(() => {
        window.dataLayer.push({
            event: 'productBestOffer',
            eventCategory: '',
            eventAction: 'widgetShown',
            eventLabel: ''
        });
    }, []);

    const items = company.offers.map(offer => (
        <CompanyViewBestOffersItem key={offer.productName} {...offer} />
    ));

    const responsiveData = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 8,
            slidesToSlide: 8
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 8,
            slidesToSlide: 8
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 8,
            slidesToSlide: 8
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 4,
            slidesToSlide: 4
        }
    };

    return (
        <div className="best-offers container">
            <div className="best-offers__header">
                <h2 className="best-offers__title">
                    Najchętniej kupowane produkty w
                    {' '}
                    {company.name}
                </h2>
                <div className="best-offers__info">
                    Oferty pochodzą z serwisu
                    {' '}
                    <img
                        className="best-offers__info-img"
                        alt="Skapiec.pl"
                        src="https://ocdn.eu/opineo/assets/logo_skapiec_sm.png"
                        width="61px"
                        height="18px"
                        loading="lazy"
                    />
                </div>
            </div>
            {company.dsaPageUrl && (
                <a
                    className="best-offers__dsa-link"
                    href={company.dsaPageUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    &#x24D8;
                </a>
            )}
            <Carousel
                responsive={responsiveData}
                arrows={true}
                dots={false}
                infinite={false}
                customButtonGroup={<CompanyViewBestOffersNav />}
                renderButtonGroupOutside={true}
            >
                {items}
            </Carousel>
        </div>
    );
};

export default CompanyViewBestOffersDesktop;
